module.exports = __webpack_public_path__ + "static/media/(V)-09-Capim-Dourado-bijuterias.0cd952e5.jpg";